import { combineReducers } from 'redux';

import pedido from './pedido/pedidoReducers';
import asyncPedido from './asyncPedido/asyncPedidoReducers';

export default combineReducers({
  pedido,
  asyncPedido,
});
